import { QuizSubmissionResponse } from './types';

const MACRO_KEY_OVERRIDES: Record<string, string> = {
  caloriesInKcal: 'calories',
};

/**
 * Builds query params for the `/menu` page's pre-selected filtering functionality.
 * @param quizResults
 */
export const buildMenuFilterQueryParams = (
  quizResults: Partial<QuizSubmissionResponse>,
): Record<string, string | string[]> => {
  const query: Record<string, string | string[]> = {};

  if (quizResults.tagIds?.length) {
    query.tagId = quizResults.tagIds.map(String);
  }

  if (quizResults.ingredientToAvoidIds?.length) {
    query.ingredientToAvoidId = quizResults.ingredientToAvoidIds.map(String);
  }

  if (quizResults.nutritionalFacts) {
    for (const [factKey, range] of Object.entries(
      quizResults.nutritionalFacts,
    )) {
      if (!range) {
        continue;
      }

      const macroKey = MACRO_KEY_OVERRIDES[factKey] ?? factKey;
      query[`${macroKey}Macro`] = `${range.min}~${range.max ?? 'null'}`;
    }
  }

  return query;
};
